import React, { FC, useMemo } from 'react'
import Select from '@shared/ui/Form/Single/Select/Select'
import { FieldSelect, SelectOption } from '@shared/types/fields/fields'
import { getDefaultField } from '@shared/lib/fields/getDefaultField'

interface Props {
  disabled?: boolean
  hideDisabledValue?: boolean
  className?: string
  value?: { month: number; year: number; isEmpty: boolean } | null
  onChange?: (value: { month: number; year: number; isEmpty: boolean }, option: SelectOption) => void
}

const MONTH_NAMES = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
]

// пока нет бека пусть так валяются, собственно так выглядит формат ключей
// TODO: обновить отдельные детали реализации бека
const MOCK_EMPTY_KEYS = new Set<string>(['2025-02', '2025-04'])

const buildOptions = (
  fromYear: number,
  fromMonthIndex: number,
  toYear: number,
  toMonthIndex: number,
): SelectOption[] => {
  const options: SelectOption[] = []

  for (let y = toYear; y >= fromYear; y--) {
    const startM = y === fromYear ? fromMonthIndex : 0
    const endM = y === toYear ? toMonthIndex : 11

    for (let m = endM; m >= startM; m--) {
      const key = `${y}-${String(m + 1).padStart(2, '0')}`
      const isEmpty = MOCK_EMPTY_KEYS.has(key)
      options.push({
        value: key,
        label: `${MONTH_NAMES[m]} ${y}`,
        disabled: false,
        month: m + 1,
        year: y,
        isEmpty,
      })
    }
  }

  return options
}

// Выбирашка для месяцев
const MonthSelect: FC<Props> = ({
  className = '',
  value = null,
  onChange,
  disabled = false,
  hideDisabledValue = false,
}) => {
  const now = new Date()
  const options = useMemo(() => buildOptions(2025, 0, now.getFullYear(), now.getMonth()), [now])

  const selectedKey = value ? `${value.year}-${String(value.month).padStart(2, '0')}` : null
  const selectedOption = selectedKey ? options.find((o) => o.value === selectedKey) || null : null

  const field: FieldSelect = getDefaultField('select', {
    name: 'month-select',
    settings: {
      options: options,
    },
    disabled: disabled,
    value: selectedOption,
  })

  const handleChange = (option: SelectOption) => {
    onChange &&
      onChange(
        {
          month: Number(String(option.month || '').padStart(2, '0')),
          year: option.year,
          isEmpty: !!option.isEmpty,
        },
        option,
      )
  }

  return (
    <Select field={field} handleChange={handleChange} hideDisabledValue={hideDisabledValue} className={className} />
  )
}

export default MonthSelect
